export const focusVisibleAttribute = "data-focus-visible-added";
//# sourceMappingURL=focusVisible.js.map